import axios from "axios";
import {showMessage} from './messageBox';
axios.defaults.baseURL = process.env.REACT_APP_EYMIO_BASE_URL;

export const fetchUserPreference = (obj) => {
    return {
        type: 'FETCH_PREFERENCE_SUCCESS',
        data:obj
    }
}

export const saveUserPreference = (obj,token, history) => {
    //console.log('KYLL UAseaS',obj)
    return dispatch => {
        //check if user already exist
        return axios.get(`/userpreferences/existing_user?access_token=${token}&userId=${obj.user_id}`)
        .then(res => {
            if(res.data.preference.length == 0){
                //If not exist then add
                return axios.post("/userpreferences?access_token=" + token, obj)
                    .then(res => {
                        //todo

                        dispatch(showMessage({
                            type: "success",
                            title: "Success",
                            message: 'User Preferences successfuly saved.',
                            onClick: () => {
                                window.location.reload()
                            }
                        }))
                    })
                    .catch(err => {
                        //todo

                        dispatch(showMessage({
                            type: "error",
                            title: "Unhandled Error",
                            message: 'Unable to save. Please contact Admin.',
                            onClick: () => {
                                window.location.reload()
                            }
                        }))
                    })
            }else{
                //Patch existing data
                return axios.patch(`/userpreferences/${res.data.preference[0].id}?access_token=${token}`, obj)
                .then(res => {
                    //todo

                    dispatch(showMessage({
                        type: "success",
                        title: "Success",
                        message: 'User Preferences successfuly saved.',
                        onClick: () => {
                            // history.push('/user-preference')
                            window.location.reload()
                        }
                    }))
                })
                .catch(err => {
                    //todo

                    dispatch(showMessage({
                        type: "error",
                        title: "Unhandled Error",
                        message: 'Unable to save. Please contact Admin.',
                        onClick: () => {
                            window.location.reload()
                        }
                    }))
                })
            }
        })
        .catch(err => {
            dispatch(showMessage({
                type: "error",
                title: "Unhandled Error",
                message: 'Unable to save. Please contact Admin.',
                onClick: () => {
                    window.location.reload()
                }
            }))
        })
    }
}

export const getUserPreferences = (id, token) => {
    
    return dispatch => {
        return axios.get(`/userpreferences/existing_user?access_token=${token}&userId=${id}`)
        .then(res => {
            //Save data to redux store
            console.log('res.preference.data',res.data.preference)
            dispatch(fetchUserPreference(res.data.preference[0]))
        })
        .catch(err => {
            //todo
            console.log('res.preference.data',err)
        })
    }
}


// WEBPACK FOOTER //
// ./src/actions/userPreference.js